export const TSK_I18N = 'TSK_I18N'
